<template>
    <div class="accountrecorder">
        <topNav :title="title"></topNav>
        
        <div v-if="!isLoading">
            <div class="btns" v-show="carList && carList.length<5">
                <van-button type="info" @click="addCar">前往绑定车辆</van-button>
            </div>
            <section class="list list_mycars">
              <ul v-show="carList && carList.length">
                <li class="car" v-for="(item, index) in carList" :key="index" @click="chooseCar(item)">
                    <div class="carnum">{{item.vehicleno?item.vehicleno.slice(0,2): ''}}<b></b>{{item.vehicleno?item.vehicleno.slice(2): ''}}</div>
                </li>
              </ul>
              <p class="emptyTip" v-show="!carList.length">暂无车辆</p>
              <p class="tips" v-show="!carList.length">可尝试登录后再获取车牌信息</p>
            </section>
        </div>
          
        <div class="loadmore" v-if="isLoading"><van-loading type="spinner" /></div>
    </div>

</template>
<script>
import topNav from "../../topnav/topnav"
import {DETAIL as API} from "@/assets/api"

export default {
  name: 'electronicInvoice',
  components:{
     topNav,
  },
  data() {
    return {
      title:"选择车辆",
      isLoading: false,
    }
  },
  computed: {
    carList(){
      let list = Array.isArray(this.$store.state.cars) ? this.$store.state.cars : []
      return list
    }
  },
  methods:{
    chooseCar(item){
      this.$router.push({name: 'invoiceChoosePark', query: {carNum: item.vehicleno}})
    },
    addCar(){
      let nextRoute = this.$store.state.loginStatus ? 'bindCar' : 'login'
      this.$router.push({name: nextRoute})
    },
    getCarList(){
      let req = {}
      let phonenumber = this.$store.state.phonenumber
      let originalId = sessionStorage.getItem("originalId")
      if(!phonenumber && !originalId){
        this.$toast('暂无用户信息')
        return
      }
      if(phonenumber){
        req.phonenumber = phonenumber
      }else{
        req.originalId = originalId
      }
      this.isLoading = true
      this.$http({
          method: 'post',
          url: API.GET_CARLIST,
          data: this.qs.stringify(req),
          success: function(data){
            this.isLoading = false
            if(data.code == 0){
              let cars = data.data && data.data.length && data.data[0].cars ? data.data[0].cars : []
              this.$store.commit('getBindCars', cars)
            }else{
                this.$toast({
                    duration: 1200,
                    message: data.msg
                });
            }
          }.bind(this),
          error: function(error){
              this.isLoading = false
              console.log(error)
          }
      })
      
    },
  },
  created(){
    this.getCarList()
  },
  destroyed(){
    
  },
}
</script>
<style lang="less" scoped>
.accountrecorder{
  min-height: 100vh;
  border-bottom:1px solid #fff; 
  background-color: #fff;
  box-sizing: border-box;
}

.list_mycars{
  .car{
    position: relative;
    height: 80px;
    width: 92%;
    margin: 10px auto;
    background: url('../../../../static/images/option_bg.png') center no-repeat;
    background-size: 100%;
    border-radius: 10px;
    .carnum{
      font-size: 24px;
      text-align: center;
      line-height: 80px;
      color: #fff;
      font-weight: 400;
      b{
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 8px;
        line-height: 90px;
        background: #fff;
        margin: 0 7px;
        margin-bottom: 4px;
      }
    }
    .btn{
      height: 23px;
      padding: 0 10px;
      position: absolute;
      top: 10px;
      right: 10px;
      color: #fff;
      font-size: 10px;
      text-align: center;
      line-height: 23px;
      background-color: hsla(0,0%,100%,.2);
      border-radius: 11px;
    }
  }
  .emptyTip{
    font-size: 16px;
    text-align: center;
    line-height: 60px;
  }
  .tips{
    text-align: center;
    font-size: 14px;
    color: #ccc;
    span{
      color: #666;
      text-decoration: underline;
    }
  }
}

.btns{
  padding: 10px 15px 0;
  .van-button{
    border-radius: 3px; 
    outline: none;
    border: none;
    width: 100%;
    background-color: #07c160;
    color: #fff;
  }
}
.loadmore{
  padding: 10px 0;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/my/electronicInvoice/index.vue